import { createI18n } from 'vue-i18n'
// 导入语言包
import zhCN from './zh-CN/index'
import en from './en/index'
import { getAllMultilingualConfig } from '@/api/common/MultilingualConfig.api'

// 获取本地存储的语言，默认中文
const getLocale = () => {
  const localLang = localStorage.getItem('locale')
  if (['zh-CN', 'en'].includes(localLang as string)) {
    return localLang as string
  }
  // 若本地无存储，默认使用中文
  return 'zh-CN'
}

// 递归处理对象中的 @ 符号，将其转换为 {'@'}
const deepEscapeAtSymbol = (data: any): any => {
  if (typeof data === 'string') {
    // 先还原可能已存在的转义，再统一转义
    // 注意：这里假设用户不会真的需要输出 "{'@'}" 这种字面量字符串
    return data.replace(/{'@'}/g, '@').replace(/@/g, "{'@'}")
  }
  if (Array.isArray(data)) {
    return data.map((item) => deepEscapeAtSymbol(item))
  }
  if (data !== null && typeof data === 'object') {
    const result: any = {}
    for (const key in data) {
      result[key] = deepEscapeAtSymbol(data[key])
    }
    return result
  }
  return data
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 开启 Composition API 模式（必须开启，适配Vue3 TS）
  locale: getLocale(), // 默认语言
  fallbackLocale: 'zh-CN', // 语言加载失败时的备用语言
  messages: {
    'zh-CN': deepEscapeAtSymbol(zhCN),
    'en': deepEscapeAtSymbol(en),
  },
})

// 辅助函数：将扁平的 key (如 'a.b.c') 转换为嵌套对象
function setNestedProperty(obj: any, path: string, value: any) {
  const keys = path.split('.')
  let current = obj
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (i === keys.length - 1) {
      current[key] = value
    } else {
      current[key] = current[key] || {}
      current = current[key]
    }
  }
}

// 加载后端多语言配置
export const loadLocaleMessages = async () => {
  try {
    const res: any = await getAllMultilingualConfig()
    // 假设返回的数据在 res.data 或 res 中，且为数组
    // 请根据实际后端返回结构进行调整
    const data = res?.data || res
    
    if (Array.isArray(data)) {
      const zhMessage: any = {}
      const enMessage: any = {}

      data.forEach((item: any) => {
        // 假设字段名为 configCode, contentZh, contentEn
        // 如果后端字段名不同，请在此处修改
        const key = item.configCode
        if (key) {
          if (item.contentZh) {
            setNestedProperty(zhMessage, key, item.contentZh)
          }
          if (item.contentEn) {
            setNestedProperty(enMessage, key, item.contentEn)
          }
        }
      })

      i18n.global.mergeLocaleMessage('zh-CN', deepEscapeAtSymbol(zhMessage))
      i18n.global.mergeLocaleMessage('en', deepEscapeAtSymbol(enMessage))
    }
  } catch (error) {
    console.error('Failed to load multilingual config:', error)
  }
}

export default i18n
